module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-1"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4 font-size-16"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Tickets abiertos de")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("  " + _vm._s(_vm.tipo.toLowerCase()) + " ")]), _c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v(" por estado")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12 grey--text"
  }, [_vm._v("Listado general de tickets")])], 1), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "info",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.reRenderChart()
      }
    }
  }, [_c('v-icon', [_vm._v("sync")]), _vm._v("Actualizar")], 1)], 1), _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('div', {
    staticClass: "d-flex mb-4 ml-4"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-select', {
    attrs: {
      "solo": "solo",
      "items": _vm.tiempos,
      "item-text": "name",
      "item-value": "id",
      "disabled": _vm.isLoading,
      "label": "Tiempo",
      "dense": "dense",
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.getDatesForChart()
      }
    },
    model: {
      value: (_vm.tiempo),
      callback: function($$v) {
        _vm.tiempo = $$v
      },
      expression: "tiempo"
    }
  }), _c('div', {
    staticClass: "flex-1 d-flex"
  }, [_c('div', {
    staticClass: "ml-4"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Desde",
      "solo": "solo",
      "dense": "dense",
      "type": "date",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.desde),
      callback: function($$v) {
        _vm.desde = $$v
      },
      expression: "desde"
    }
  })], 1), _c('div', {
    staticClass: "ml-4"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Hasta",
      "solo": "solo",
      "dense": "dense",
      "type": "date",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.hasta),
      callback: function($$v) {
        _vm.hasta = $$v
      },
      expression: "hasta"
    }
  })], 1)])], 1)]), (_vm.renderChart) ? _c('LineChart', {
    ref: "lineChart",
    attrs: {
      "tipo": _vm.tipo,
      "desde": _vm.desde,
      "hasta": _vm.hasta
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aceb35f0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_card_chart_line_cantidad_total_tickets_por_estados.vue
// module id = 524
// module chunks = 1